import { FieldErrors, UseFormRegisterReturn } from "react-hook-form";
import { z } from "zod";

import PasswordRequirements from "~/common/components/PasswordRequirements";
import SignUpFormLayout from "~/common/components/signUp/SignUpFormLayout";
import SignUpProgress from "~/common/components/signUp/SignUpProgress";
import Input from "~/common/components/ui/Input";
import { passwordSchema } from "~/providers/utils";

export type PasswordsSchemaType = z.infer<typeof passwordSchema>;

interface TeamMemberPasswordFormProps {
  handleGoBack: () => void;
  totalSteps: number;
  register: (data: keyof PasswordsSchemaType) => UseFormRegisterReturn<string>;
  onNext: () => Promise<void>;
  enteredPassword: string;
  step: number;
  pendingRequest?: boolean;
  errors?: FieldErrors<PasswordsSchemaType>;
}

export const TeamMemberPasswordForm = ({
  onNext,
  register,
  handleGoBack,
  totalSteps,
  enteredPassword,
  step,
  pendingRequest,
  errors,
}: TeamMemberPasswordFormProps) => (
  <>
    <SignUpProgress step={step} totalSteps={totalSteps} />
    <SignUpFormLayout
      title="Create password"
      handleGoBack={handleGoBack}
      handleData={onNext}
      pendingRequest={pendingRequest}
      submitLabel="Sign up"
    >
      <Input
        id="password"
        label="Password"
        type="password"
        {...register("password")}
        error={errors?.password?.message}
      />
      <Input
        id="passwordConfirmation"
        label="Confirm password"
        type="password"
        {...register("passwordConfirmation")}
        error={errors?.passwordConfirmation?.message}
      />
      <PasswordRequirements password={enteredPassword} />
    </SignUpFormLayout>
  </>
);
